export default __webpack_public_path__ + "static/media/heart_on.1dc32793.svg";